import ArchiveKnowledgeDatatableView from '../../../components/UI/KnowledgeDatatableComponent/ArchiveKnowledgeDatatableView'

import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { useTranslation } from 'react-i18next'

const ArchivedKnowledge = (props: any) => {
  const { t } = useTranslation('translation')

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader title={t('Archived Knowledge')} />
      <ArchiveKnowledgeDatatableView />
    </section>
  )
}

export default ArchivedKnowledge
